import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navItems = [
    { label: '首页', href: '#hero' },
    { label: '常见问题', href: '#faq' },
    { label: '平台特色', href: '#features' },
    { label: '热度榜单', href: '#ranking' },
    { label: '精选专题', href: '#carousel' },
  ];

  return (
    <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60' : 'bg-transparent'}`}>
        <div className="px-4 md:px-6 mx-auto max-w-[1440px]">
          <div className="flex items-center justify-between h-[72px]">
            <a href="#hero" className="flex items-center gap-2 no-underline">
              <span className="text-2xl md:text-3xl font-heading font-bold text-accent-500">90影视</span>
            </a>

            <nav className="hidden md:flex items-center gap-1">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="whitespace-nowrap px-4 py-2 text-sm font-medium text-foreground-700 hover:text-accent-500 rounded-lg hover:bg-background-100 transition-colors duration-200"
                >
                  {item.label}
                </a>
              ))}
            </nav>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-accent-500 transition-colors"
              aria-label="Toggle menu"
            >
              <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-background-50/98 backdrop-blur-md border-b border-background-200/60">
            <div className="px-4 py-3 flex flex-col gap-1">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="whitespace-nowrap px-4 py-3 text-sm font-medium text-foreground-700 hover:text-accent-500 hover:bg-background-100 rounded-lg transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </header>

      <section id="hero" className="relative pt-[72px] min-h-[600px] md:min-h-[700px] flex items-center bg-background-50">
        <div className="w-full px-4 md:px-6 mx-auto max-w-[1440px]">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 py-10 md:py-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
                <i className="ri-shield-check-line text-sm"></i>
                <span>官方认证入口 · 安全稳定访问</span>
              </div>

              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-3">
                90影视 — 高清电影电视剧<br className="hidden sm:block" />免费在线观看平台
              </h1>

              <p className="text-base md:text-lg text-accent-600 font-medium mb-5">
                海量资源 · 全集不缓冲 · 最新地址一键直达
              </p>

              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
                90影视官网致力于为广大影迷提供高清电影、热门电视剧、综艺动漫等一站式免费在线观看服务。
                平台每日同步更新最新院线大片与卫视热播剧集，无需注册、无广告打扰，支持手机与电脑多端访问。
                当前热播专题涵盖暑期档新片、高分经典回顾及日韩美剧精选，最新入口实时更新，确保您随时随地畅享流畅观影体验。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
                <div className="flex items-center gap-2 text-foreground-700">
                  <i className="ri-movie-2-line text-lg text-accent-500"></i>
                  <span className="text-sm"><strong className="text-accent-600 font-semibold">10,000+</strong> 影视资源</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-700">
                  <i className="ri-refresh-line text-lg text-accent-500"></i>
                  <span className="text-sm"><strong className="text-accent-600 font-semibold">每日更新</strong> 50+部</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-700">
                  <i className="ri-play-circle-line text-lg text-accent-500"></i>
                  <span className="text-sm"><strong className="text-accent-600 font-semibold">99.9%</strong> 播放成功率</span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a href="#app" className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200">
                  <i className="ri-download-2-line text-lg"></i>
                  下载APP安全观影
                </a>
                <a href="#contact" className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 border-2 border-foreground-300 text-foreground-700 hover:border-accent-500 hover:text-accent-500 font-semibold text-sm rounded-lg transition-all duration-200">
                  <i className="ri-mail-send-line text-lg"></i>
                  联系我们 / 投稿
                </a>
              </div>
            </div>

            <div className="flex-1 w-full lg:max-w-[50%]">
              <div className="relative w-full aspect-[4/3] md:aspect-[16/10] rounded-xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20composition%20with%20warm%20golden%20amber%20lighting%2C%20film%20reel%20texture%20overlay%2C%20soft%20dramatic%20shadows%2C%20movie%20clapperboard%20silhouette%2C%20elegant%20dark%20background%20with%20warm%20accents%2C%20luxurious%20cinema%20atmosphere%2C%20no%20text%2C%20artistic%20photography%20style%20with%20bokeh%20effects&width=1200&height=900&seq=hero-main-visual-01&orientation=landscape"
                  alt="90影视 - 高清电影电视剧免费在线观看平台"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}